import { debounce } from 'lodash';

const SELECTOR_LIST = '.membership-levels-benefits__tab-list';
const SELECTOR_RADIO = '.membership-levels-benefits__tab-radio';
const SELECTOR_ITEM = '.membership-levels-benefits__tab-item';
const SELECTOR_INDICATOR = '.membership-levels-benefits__tab-indicator';

const supportsAnchorPositioning = CSS.supports('anchor-name', '--tab');

export default function () {
    document.querySelectorAll(SELECTOR_LIST).forEach(list => {
        const indicator = list.querySelector(SELECTOR_INDICATOR);

        const positionIndicator = item => {
            if (supportsAnchorPositioning || !indicator || !item) {
                return;
            }

            indicator.style.setProperty('--tab-indicator-left', `${item.offsetLeft}px`);
            indicator.style.setProperty('--tab-indicator-width', `${item.offsetWidth}px`);
        }

        const centerItemInView = (item, behavior) => {
            const listRect = list.getBoundingClientRect();
            const itemRect = item.getBoundingClientRect();

            const itemCenter = itemRect.left + itemRect.width / 2;
            const listCenter = listRect.left + listRect.width / 2;

            list.scrollBy({ left: itemCenter - listCenter, behavior });
        }

        const update = ({ scroll, behavior } = {}) => {
            const checked = list.querySelector(`${SELECTOR_RADIO}:checked`);
            const item = checked && checked.closest(SELECTOR_ITEM);

            if (!item) {
                return;
            }

            positionIndicator(item);

            if (scroll) {
                centerItemInView(item, behavior);
            }
        }

        list.addEventListener('change', event => {
            if (event.target.matches(SELECTOR_RADIO)) {
                update({ scroll: true, behavior: 'smooth' });
            }
        });

        window.addEventListener('resize', debounce(() => update(), 250));

        update({ scroll: true });
    });
}
